module.exports = __webpack_public_path__ + "img/HZ-A1515.a095c9bc.jpg";